import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

/**
 * Função responsável por gerar e disponibilizar para download um arquivo Excel (.xlsx)
 * contendo o relatório completo dos erros retornados na importação de um arquivo CSV.
 * -----------------------------------------------------------------------------
 * 1. Recebe uma lista de erros já parseada no formato:
 *      { linha: number|null, coluna: number|null, mensagem: string }
 *
 * 2. Cria uma nova planilha via ExcelJS contendo três colunas fixas:
 *      • Linha — número da linha onde ocorreu o erro ou "-" caso não exista
 *      • Coluna — número da coluna onde ocorreu o erro ou "-" caso não exista
 *      • Erro identificado — mensagem descritiva retornada pelo backend
 *
 * 3. Formatação aplicada automaticamente:
 *      • Cabeçalho destacado em negrito
 *      • Ajuste automático de largura das colunas (AutoFit)
 *
 * 4. Após montar e estilizar o arquivo, o conteúdo é convertido em ArrayBuffer
 *    e disponibilizado para download com nome: relatorio_erros_importacao.xlsx
 *
 */
export const exportErrorsToExcel = async (errorsList) => {
  if (!errorsList || errorsList.length === 0) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Erros da Importação");

  // Cabeçalho
  worksheet.columns = [
    { header: "Linha", key: "linha" },
    { header: "Coluna", key: "coluna" },
    { header: "Erro identificado", key: "mensagem" }
  ];

  // Estilização do cabeçalho
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
  });

  errorsList.forEach(err => {
    worksheet.addRow({
      linha: err.linha ?? "-",
      coluna: err.coluna ?? "-",
      mensagem: err.mensagem
    });
  });

  // AutoFit
  worksheet.columns.forEach(column => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, cell => {
      const length = cell.value ? cell.value.toString().length : 10;
      if(length > maxLength) maxLength = length;
    });
    column.width = maxLength + 4;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    "relatorio_erros_importacao.xlsx"
  );
};